import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail/praise-icon.svg';
const PraiseIcon = () => React.createElement(IconSvg, null);
export default PraiseIcon;
